<template>
  <img v-if="!visible && !other" src="@/assets/image-not-found.png" />
  <a-icon v-else-if="!visible && other"
    :type="load_icon(other)"
    style="font-size: 48px"
  />
  <img v-else :src="source" />
</template>

<script>
import GlobalMethod from "@/mixins/GlobalMethod.js";
export default {
  name: "Image-Component",
  mixins: [GlobalMethod],
  props: {
    source: {
      default: '/assets/image-not-found.png',
      type: String,
    },
  },
  data(){
    return {
      visible: false,
      other: null,
      type:[
        "jpg",
        "jpeg",
        "png",
      ]
    }
  },
  mounted() {
    this.visible = this.type.find(this.checkString)
    if(!this.visible){
      this.other = this.typeFileFromName(this.label)
    }
  },
  computed:{
    label(){
      return (this.source ? this.source.toLowerCase() : null)
    }
  },
  methods: {
    checkString(val) {
      return val == this.label;
    }
  },
};
</script>

<style>
</style>